// @flow
import React, { type Node } from 'react';

import { StatementsData } from './StatementsData';
import { RecipientsData } from './RecipientsData';


type Props = {
  children: Node
}

const StatementsDataContainer = ({ children }: Props) => (
  <StatementsData>
    <RecipientsData>
      {children}
    </RecipientsData>
  </StatementsData>
);

export default StatementsDataContainer;
